import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-icon-first-measurement-to-process',
    templateUrl: './first-measurement-to-process.component.svg',
    styleUrls: ['./first-measurement-to-process.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FirstMeasurementToProcessComponent {}
